import i18n from "../../i18n";

export const PUBLIC_WEBSITE_LANGUAGE_KEY = "public_website_locale";

export const normalizePublicWebsiteLocale = (language) =>
  String(language || "en").split("-")[0].toLowerCase() === "ar"
    ? "ar"
    : "en";

const changePublicWebsiteLanguageIfNeeded = (locale) => {
  const currentLocale = normalizePublicWebsiteLocale(
    i18n.resolvedLanguage || i18n.language,
  );

  if (currentLocale !== locale) {
    i18n.changeLanguage(locale === "ar" ? "ar-EG" : "en-GB");
  }
};

const persistPublicWebsiteLocale = (locale) => {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(PUBLIC_WEBSITE_LANGUAGE_KEY, locale);
  } catch {
    // The website still works with the API default when storage is unavailable.
  }
};

export const readStoredPublicWebsiteLocale = () => {
  if (typeof window === "undefined") return null;

  try {
    const locale = window.localStorage.getItem(PUBLIC_WEBSITE_LANGUAGE_KEY);
    return locale === "ar" || locale === "en" ? locale : null;
  } catch {
    return null;
  }
};

export const resolvePublicWebsiteLocale = (defaultLanguage) =>
  readStoredPublicWebsiteLocale() ||
  normalizePublicWebsiteLocale(defaultLanguage);

export const applyPublicWebsiteLanguage = (language) => {
  const locale = normalizePublicWebsiteLocale(language);

  persistPublicWebsiteLocale(locale);
  changePublicWebsiteLanguageIfNeeded(locale);

  return locale;
};

export const restorePublicWebsiteLanguage = (defaultLanguage) => {
  const locale = resolvePublicWebsiteLocale(defaultLanguage);

  persistPublicWebsiteLocale(locale);
  changePublicWebsiteLanguageIfNeeded(locale);

  return locale;
};
